module.exports = __webpack_public_path__ + "static/images/mandiri.3woS1bW.svg";